import React from 'react';
import { useRecaptchaContext } from '../../../../contexts/recaptcha';
import { useRegisterComponent } from '../../../orchestrator';
import { SignupRecaptchaContainer } from './styled';

export const SignupRecaptcha = () => {
  useRegisterComponent(SignupRecaptcha.name);

  const { enabled: recaptchaEnabled, component: recaptchaComponent } = useRecaptchaContext();

  const shouldShow = recaptchaEnabled && recaptchaComponent;

  if (!shouldShow) {
    return null;
  }

  return <SignupRecaptchaContainer>{recaptchaComponent}</SignupRecaptchaContainer>;
};
